import { ChangeEvent, FC, useEffect, useState } from "react";
import "./AdminTickets.css";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import { getTicketBySearch } from "../../../redux/requests/AdminRequests";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

interface IAdminTicketsProps {}

const AdminTickets: FC<IAdminTicketsProps> = () => {
  const dispatch = useAppDispatch();

  const tickets = useAppSelector((state) => state.admin.tickets);

  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    dispatch(getTicketBySearch(""));
  }, []);

  const onSearchInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const onSearchButtonClick = () => {
    dispatch(getTicketBySearch(search));
  };

  return (
    <div className="admin-tickets">
      <div className="dialog-list">
        <div className="search-box">
          <input
            type="text"
            placeholder="Поиск по имени клиента"
            onChange={onSearchInputChange}
          />
          <button onClick={onSearchButtonClick}>Поиск</button>
        </div>
        <h3>Завершённые диалоги</h3>
        {tickets.map((item) => {
          return (
            <Link
              key={item.id}
              to={`dialog/${item.id}`}
              style={{ textDecoration: "none" }}
            >
              <div
                className="dialog-item"
                style={{ borderBottom: "1px solid var(--light-gray)" }}
              >
                <div className="dialog-title">Диалог #{item.id}</div>
                <div className="dialog-meta">
                  Оператор: {item.operator?.name || "Неизвестно"} | Оценка:{" "}
                  {item.mark} | Клиент: {item.user?.name || "Неизвестно"} |
                  Создано:{" "}
                  {item.createdAt
                    ? dayjs(item.createdAt).format("YYYY-MM-DD HH:mm")
                    : "-"}{" "}
                  | Принято:{" "}
                  {item.acceptedAt
                    ? dayjs(item.acceptedAt).format("YYYY-MM-DD HH:mm")
                    : "-"}{" "}
                  | Закрыто:{" "}
                  {item.closedAt
                    ? dayjs(item.closedAt).format("YYYY-MM-DD HH:mm")
                    : "-"}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default AdminTickets;
